import { render, staticRenderFns } from "./MypageList.vue?vue&type=template&id=2ed96ec5"
import script from "./MypageList.ts?vue&type=script&lang=ts&external"
export * from "./MypageList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports